var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticStyle:{"padding":"0","border":"none"},attrs:{"content":_vm.errorMessage,"placement":"bottom"}},[_c('i',{staticClass:"el-icon-warning error-icon",staticStyle:{"color":"#ff392e","background-color":"white","border-radius":"50%","cursor":"pointer","margin":"0 5px 10px -10px"},style:({
      display: _vm.isVisible ? 'inline' : 'none',
    }),attrs:{"disabled":_vm.buttonDisabled},on:{"click":function($event){return _vm.resendMessage()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }